const isConflict = async (to, from, next) => {
  if (to.params.version) {
    next();
  } else {
    next('/');
  }
};

const updateRoutes = [
  {
    path: '/update',
    name: 'update',
    component: () => import('@/portals/UpdateApp/UpdateApp'),
    beforeEnter: isConflict
  }
];

export { updateRoutes as default };
